/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveDangerousDebtsRequest
 */
export interface SaveDangerousDebtsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasRentArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasUtilityArrears?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasOpenPenalties?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasInstallmentAgreement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    canMeetInstallmentAgreement?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    hasChildrenWithMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    paysFullMaintenance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDangerousDebtsRequest
     */
    isMaintenanceGarnished?: boolean | null;
}

/**
 * Check if a given object implements the SaveDangerousDebtsRequest interface.
 */
export function instanceOfSaveDangerousDebtsRequest(value: object): value is SaveDangerousDebtsRequest {
    return true;
}

export function SaveDangerousDebtsRequestFromJSON(json: any): SaveDangerousDebtsRequest {
    return SaveDangerousDebtsRequestFromJSONTyped(json, false);
}

export function SaveDangerousDebtsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveDangerousDebtsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hasRentArrears': json['hasRentArrears'] == null ? undefined : json['hasRentArrears'],
        'hasUtilityArrears': json['hasUtilityArrears'] == null ? undefined : json['hasUtilityArrears'],
        'hasOpenPenalties': json['hasOpenPenalties'] == null ? undefined : json['hasOpenPenalties'],
        'hasInstallmentAgreement': json['hasInstallmentAgreement'] == null ? undefined : json['hasInstallmentAgreement'],
        'canMeetInstallmentAgreement': json['canMeetInstallmentAgreement'] == null ? undefined : json['canMeetInstallmentAgreement'],
        'hasChildrenWithMaintenance': json['hasChildrenWithMaintenance'] == null ? undefined : json['hasChildrenWithMaintenance'],
        'paysFullMaintenance': json['paysFullMaintenance'] == null ? undefined : json['paysFullMaintenance'],
        'isMaintenanceGarnished': json['isMaintenanceGarnished'] == null ? undefined : json['isMaintenanceGarnished'],
    };
}

export function SaveDangerousDebtsRequestToJSON(json: any): SaveDangerousDebtsRequest {
    return SaveDangerousDebtsRequestToJSONTyped(json, false);
}

export function SaveDangerousDebtsRequestToJSONTyped(value?: SaveDangerousDebtsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasRentArrears': value['hasRentArrears'],
        'hasUtilityArrears': value['hasUtilityArrears'],
        'hasOpenPenalties': value['hasOpenPenalties'],
        'hasInstallmentAgreement': value['hasInstallmentAgreement'],
        'canMeetInstallmentAgreement': value['canMeetInstallmentAgreement'],
        'hasChildrenWithMaintenance': value['hasChildrenWithMaintenance'],
        'paysFullMaintenance': value['paysFullMaintenance'],
        'isMaintenanceGarnished': value['isMaintenanceGarnished'],
    };
}

